import React from "react";
import { graphql, Link } from "gatsby";
import { Button, Row, Col, Card, Icon } from "antd";
import Layout from "../components/TheLayout";
import "../components/style/index.less";
import Hero from "../components/Hero";
import { Container } from "../utils/Responsive";
import { HTMLContent } from "../components/Content";
import FeaturedPublications from "../components/FeaturedPublications";
import bioIcon from "../img/biology.png";
import teach from "../img/teach.png";
import collaborate from "../img/collaborate.png";
const ReserchCard = props => {
  return (
    <Col
      md={{ span: 8 }}
      className={`${props.className} text-center research-card`}
      {...props}
    >
      <Card hoverable>{props.children}</Card>
    </Col>
  );
};
export default ({ data }) => {
  return (
    <Layout>
      <Hero />
      <Container>
        <Row gutter={16}>
          <Col md={{ span: 12, offset: 6 }} className="text-center">
            <h2 className="lead">
              A lab where fundamental and applied science meet to discover
              bioactive molecules that can change the world.
            </h2>
            <p className="lead-subtitle">
              Organometallic chemistry &bull; Biocatalysis &bull; Heterocyclic
              compounds
            </p>
          </Col>
          <ReserchCard>
            <img src={bioIcon} alt="Research icon" />
            <h3 className="focus-card-title">Research</h3>
            <p>
              Our focus is organometallic chemistry, bioactivity of heterocyclic
              compounds and biocatalysis
            </p>
            <Button type="primary" ghost>
              <Link to="/research">Read more</Link>
            </Button>
          </ReserchCard>
          <ReserchCard>
            <img src={teach} alt="Graduation hat icon" />
            <h3 className="focus-card-title">Teach</h3>
            <p>
              We are passionate about science and love sharing our knowledge.
              Our lab welcomes students who are eager to learn
            </p>
            <Button type="primary" ghost>
              <Link to="/teaching">Read more</Link>
            </Button>
          </ReserchCard>
          <ReserchCard>
            <img src={collaborate} alt="Collaboration icon" />
            <h3 className="focus-card-title">Collaborate</h3>
            <p>
              We are always looking for partners to team up with in the pursuit
              of sustainability, high efficiency and reduced waste
            </p>
            <Button type="primary" ghost>
              <Link to="/collaborations">Read more</Link>
            </Button>
          </ReserchCard>
          <Col md={{ span: 16 }}>
            <Card
              bordered={false}
              title="News &amp; Announcements"
              style={{ backgroundColor: "white" }}
            >
              {data.allMarkdownRemark.edges.map(({ node }) => {
                return (
                  <div className="news-item" key={node.id}>
                    <h3>
                      <Link to={node.fields.slug}>
                        {node.frontmatter.title}
                      </Link>
                    </h3>
                    <HTMLContent className="excerpt" content={node.excerpt} />
                    <Link to={node.fields.slug}>
                      <Icon type="arrow-right" />
                    </Link>
                  </div>
                );
              })}
            </Card>
            <Card
              bordered={false}
              title="Featured Publications"
              extra={
                <Button>
                  <Link to="/publications">View all</Link>
                </Button>
              }
            >
              <FeaturedPublications />
            </Card>
          </Col>
          <Col md={{ span: 8 }}>
            <Card style={{ backgroundColor: "white" }}>
              <a
                className="twitter-timeline"
                data-height="800"
                data-tweet-limit="2"
                data-dnt="true"
                data-theme="light"
                data-link-color="#981CEB"
                href="https://twitter.com/OpsenicaLab?ref_src=twsrc%5Etfw"
              >
                Tweets by orgbiochem
              </a>
              <div className="twitter-tweet" />
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "news" } } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          id
          html
          excerpt(pruneLength: 300)
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
